const notRequireLogInRoutes = ['Users Sign In', 'UserChangePassword']

export default notRequireLogInRoutes
